export default __webpack_public_path__ + "static/media/music.79a45641.wav";